import React from 'react';

import { Box } from '@mui/material';

interface QuestionTitleHtmlProps {
  html: string;
}

// `html` is sanitized server-side via Rails `sanitize` with a
// tag/attribute allowlist (see Jobs::WcagApplicationFlowHelper#wcag_answers_flow_props).
export const QuestionTitleHtml: React.FC<QuestionTitleHtmlProps> = ({ html }) => (
  <Box className="wcag-rich-text" component="span" dangerouslySetInnerHTML={{ __html: html }} />
);
